import { EMAIL_MATCH_REGEXP, PASSWORD_MATCH_REGEXP } from 'constants/regExp';

import * as Yup from 'yup';

export const LoginSchema = Yup.object().shape({
  email: Yup.string()
    .required('validation.email.required')
    .trim()
    .matches(EMAIL_MATCH_REGEXP, 'validation.email.invalid'),
  password: Yup.string()
    .required('validation.password.required')
    .matches(PASSWORD_MATCH_REGEXP, 'input.password.invalid'),
});
